var _defs, _g, _g2, _g3, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.06 23.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .tryps-icon-item-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3 {\n        fill: #231f20;\n      }\n\n      .tryps-icon-item-2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        stroke-width: 0px;\n      }\n\n      rect.tryps-icon-item-3 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.27,4.38c0-.71.57-1.28,1.28-1.28s1.28.57,1.28,1.28-.57,1.28-1.28,1.28h0c-.71,0-1.28-.57-1.28-1.28M16.55,0C13.95,0,11.85,2.11,11.85,4.7c-.01.48.04.96.16,1.43.23.76.65,1.46,1.21,2.02l3.33,3.25s2.05-2,3.2-3.12c.65-.6,1.13-1.36,1.39-2.2.08-.45.12-.92.11-1.38C21.25,2.11,19.15,0,16.55,0c0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.66,14.96c0-.55.45-1,1-.99.55,0,1,.45.99,1,0,.55-.45.99-1,.99-.55,0-1-.45-1-1,0,0,0,0,0,0M4.97,15.22c-.01.38.03.75.13,1.12.18.6.51,1.14.95,1.58l2.61,2.55s1.61-1.57,2.51-2.45c.51-.47.89-1.07,1.09-1.73.06-.36.09-.72.09-1.08-.03-2.04-1.71-3.66-3.75-3.63-1.99.03-3.59,1.64-3.63,3.63"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5373",
    "data-name": "Group 5373"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.27,4.38c0-.71.57-1.28,1.28-1.28s1.28.57,1.28,1.28-.57,1.28-1.28,1.28h0c-.71,0-1.28-.57-1.28-1.28M16.55,0C13.95,0,11.85,2.11,11.85,4.7c-.01.48.04.96.16,1.43.23.76.65,1.46,1.21,2.02l3.33,3.25s2.05-2,3.2-3.12c.65-.6,1.13-1.36,1.39-2.2.08-.45.12-.92.11-1.38C21.25,2.11,19.15,0,16.55,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "tryps-icon-item-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5372",
    "data-name": "Group 5372"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    className: "cls-3 tryps-icon-item-3",
    x: 11.83,
    width: 9.43,
    height: 11.4
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5374",
    "data-name": "Group 5374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    className: "cls-3",
    d: "M24.57,4.77l-2.05-.18c0,.53-.05,1.07-.14,1.59-.33,1.07-.94,2.04-1.77,2.8-1.06,1.04-2.73,2.67-3.56,3.48v8.8c0,.24.16.45.39.51l6.95,1.89c.28.08.57-.09.65-.37.01-.04.02-.09.02-.14V5.29c0-.27-.21-.5-.48-.53"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5377",
    "data-name": "Group 5377"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.66,14.96c0-.55.45-1,1-.99.55,0,1,.45.99,1,0,.55-.45.99-1,.99-.55,0-1-.45-1-1,0,0,0,0,0,0M4.97,15.22c-.01.38.03.75.13,1.12.18.6.51,1.14.95,1.58l2.61,2.55s1.61-1.57,2.51-2.45c.51-.47.89-1.07,1.09-1.73.06-.36.09-.72.09-1.08-.03-2.04-1.71-3.66-3.75-3.63-1.99.03-3.59,1.64-3.63,3.63"
  }), /*#__PURE__*/React.createElement("g", {
    className: "tryps-icon-item-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5376",
    "data-name": "Group 5376"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2001",
    "data-name": "Rectangle 2001",
    className: "cls-3 tryps-icon-item-3",
    x: 4.96,
    y: 11.53,
    width: 7.39,
    height: 8.94
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7754",
    "data-name": "Path 7754",
    className: "cls-3",
    d: "M5.35,18.43c-.56-.56-.97-1.25-1.2-2.01-.12-.46-.17-.94-.16-1.42,0-2.41,1.86-4.42,4.26-4.63v-5.2c0-.19-.13-.36-.32-.41L.51,3.11c-.22-.05-.44.09-.5.31C0,3.45,0,3.48,0,3.51v17.61c0,.19.12.35.31.4l7.42,2.05c.22.06.45-.07.51-.29,0-.04.01-.07.01-.11v-1.91l-2.9-2.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7755",
    "data-name": "Path 7755",
    className: "cls-3",
    d: "M12.31,8.82c-.72-.72-1.25-1.6-1.54-2.57-.15-.59-.22-1.2-.2-1.81v-.05h-.89c-.28,0-.52.23-.52.52v5.49c2.37.25,4.16,2.24,4.17,4.62,0,.46-.04.91-.12,1.36-.26.84-.73,1.59-1.38,2.19-.79.77-2,1.95-2.67,2.61v1.49c0,.29.23.52.52.52.04,0,.07,0,.11-.01l5.88-1.29c.24-.05.4-.26.41-.5v-8.88l-3.77-3.68Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack10);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-10.d8840596b03b14ad232e9e1497fa66c5.svg";
export { ForwardRef as ReactComponent };